






































































































import { Component, Vue } from 'vue-property-decorator';
import { SchoolUniformController, OrderController } from '@/services/request.service';
import OrderTable from './OrderTable.vue';
import { saveAs } from 'file-saver';

@Component({
  components: {
    OrderTable,
  },
})
export default class UniformDetail extends Vue {
  public fileList: Array<any> = [];
  public data: Array<any> = [];
  public info: any = {};
  public current: number = 1;
  public total: number = 0;
  public rowData: Array<any> = [];
  public pageSize: number = 4;
  public tableData: Array<any> = [];
  public created(): void {
    // this.getData();
    this.getOrderData();
  }
  public onChange(current: number): void {
    this.current = current;
    this.tableData = this.rowData.slice((this.current - 1) * this.pageSize, this.current * this.pageSize);
  }
  public getData(): void {
    const studentId: number = this.$route.query.studentId ? Number(this.$route.query.studentId) : 0;
    if (studentId) {
      SchoolUniformController.getApplicationSchoolUniform(studentId).then(res => {
        this.info = res.data;
        this.fileList = res.data.resources;
      });
    }
  }

  public getOrderData(): void {
    const studentId: number = this.$route.query.studentId ? Number(this.$route.query.studentId) : 0;
    if (studentId) {
      OrderController.getDetailsByStudentId(studentId).then(res => {
        this.data = res.data;
        this.rowData = this.data;
        this.tableData = this.data.slice((this.current - 1) * this.pageSize, this.current * this.pageSize);
        this.total = this.data.length;
      });
    }
  }

  public getChargeList(item: any): any {
    return [
      ...item.orderCharges,
      {
        chargeId: -1,
        chargeName: '合计',
        money: item.money,
        benefitMoney: item.benefitMoney,
        receivableMoney: item.receivableMoney,
        creatorEnName: '',
        creatorName: '',
        createTime: '',
      },
    ];
  }

  public openFile(resource: any): void {
    const suffixArray = ['doc', 'docx', 'xls', 'xlsx'];
    if (suffixArray.includes(resource.type)) {
      this.download(resource);
    } else {
      window.open(resource.resourceUrl);
    }
  }

  public download(info: any): void {
    saveAs(info.resourceUrl, info.name);
  }

  public jumpToDetail(): void {
    if (this.info.studentId) {
      this.$store.commit('setUniformInfo', this.info);
      this.$router.push({
        name: 'uniform',
        query: { studentId: this.info.studentId, name: this.info.name, enName: this.info.enName },
      });
    }
  }
}
